import QrCode from '@/views/qrCode/Index'

export default [
  {
    path: ':clientId/qr-code',
    name: 'qrCode.index',
    component: QrCode,
    meta: { featureKey: 'qr-code' }
  }
]
